export default "__VITE_ASSET__DZjwacM4__"